
import * as _ from 'lodash'
import {format} from 'd3-format'

const dctd3formatFunc: {[id:string]: (n: number) => string } = {}

const getD3Formatter = function(aFormatString: string){
  if(aFormatString in dctd3formatFunc){
    return dctd3formatFunc[aFormatString]
  }

const aFormatterFunc = format(aFormatString)
  dctd3formatFunc[aFormatString] = aFormatterFunc
  return aFormatterFunc
}


// @ts-ignore
if (!Number.prototype.d3format) {
// @ts-ignore
  Number.prototype.d3format = function (formatString, aNaNValue) {
    let aFormatter = getD3Formatter(formatString)
    if(Number.isNaN(this) && (aNaNValue != undefined))
      return aNaNValue
    return aFormatter(this)
  };
}

// @ts-ignore
if (!Number.d3format) {
// @ts-ignore
  Number.d3format = function (a, formatString, aNaNValue) {
    let aFormatter = getD3Formatter(formatString)
    if((Number.isNaN(a) || (a == undefined)) && (aNaNValue != undefined))
      return aNaNValue
    return aFormatter(a)
  };
}


// @ts-ignore
if (!String.prototype.d3format) {
// @ts-ignore
  String.prototype.d3format = function (formatString) {
    // @ts-ignore
    return _.toNumber(this).d3format(formatString)
  };
}
